import React from 'react'
import PropTypes from "prop-types"
import { Panel } from 'react-bootstrap'
import Carta from './Carta'
import MenusList from './MenusList'
import DrinksList from './DrinksList'

import "./Carta.less"

const RestaurantContent = ({ product, onChange }) => (    
  <React.Fragment>

    <Panel bsStyle="warning" className="bordered-panel">
      <Panel.Heading>
        <Panel.Title>📖 Menús</Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <MenusList 
          menus={product.menus}
          onChange={change => onChange(change)}
        />
      </Panel.Body>
    </Panel>

    <Panel 
      className="carta bordered-panel" bsStyle="info"
    >
      <Panel.Heading>
        <Panel.Title>📖 Carta</Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <Carta 
          carta={product.carta || { dishes: {} }}
          onChange={change => onChange({ carta: { ...product.carta, ...change } })}
        />
      </Panel.Body>
    </Panel>

    <Panel bsStyle="warning" className="bordered-panel">
      <Panel.Heading>
        <Panel.Title>Bebidas</Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <DrinksList 
          drinks={product.drinks}
          onChange={change => onChange(change)}
        />
      </Panel.Body>
    </Panel>
  </React.Fragment>
  
)

RestaurantContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
}

export default RestaurantContent